<template>
  <div>
    <div class="flex flex-col py-6 px-4 border-t border-cream-100">
      <span class="font-medium text-lg text-black uppercase">Estimated time</span>
      <span class="text-xs text-grey">Quoted prices are estimates and may be adjusted based on actual flight time and handling costs. Estimates are excluding VAT (and Italian luxury taxes), based on variable costs only and include 12 minutes for taxi time.</span>
    </div>

    <div>
      <div
        class="w-full h-10 -mb-6 lg:hidden"
        style="background: linear-gradient(to right, #FAD0C7 0%, #FFD493 27.6%, #8ADAD5 100%)"
      />
      <Swiper
        ref="swiper"
        :key="slidesPerView"
        :options="swiperOptions"
        :class="!swipable && 'pointer-events-none'"
        @transitionEnd="updateActiveSlide"
      >
        <SwiperSlide v-for="item in data" :key="item.id">
          <EstimateItem :data="item" />
        </SwiperSlide>
      </Swiper>
      <ul v-if="swipable" class="relative z-20 flex items-center justify-center mt-5">
        <li
          v-for="index in data.length" :key="index"
          class="h-1.5 mx-1 rounded-full cursor-pointer transition-300"
          :class="index - 1 === activeSlide ? 'w-4 bg-cream-600' : 'w-1.5 bg-cream-200'"
          @click="handlePagination(index - 1)"
        />
      </ul>
    </div>
    
    <div class="mt-6 px-3 xs:px-8 text-center">
      <button class="p-3 border border-cream-600 text-black uppercase font-bold open-lead-booster font-header text-xs transition-300 ease-out hover:border-cream-200" id="chatbot">
        Get info about our program
      </button>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper as Swiper, swiperSlide as SwiperSlide } from 'vue-awesome-swiper'
import formatCurrency from '@/utils/formatCurrency'
import EstimateItem from '@/components/EstimateItem'

export default {
  components: { EstimateItem, Swiper, SwiperSlide },
  props: {
    data: { type: Array, required: true },
    slidesPerView: { type: Number, required: true },
    swipable: { type: Boolean, required: true },
  },
  data () {
    return {
      activeSlide: this.initialSlide(),
    }
  },
  computed: {
    swiperOptions() {
      return {
        slidesPerView: this.slidesPerView + 0.25,
        centeredSlides: true,
        spaceBetween: 16,
        grabCursor: true,
        initialSlide: this.initialSlide(),
      }
    },
  },
  methods: {
    formatCurrency,
    initialSlide() {
      return Math.floor(0.5 * this.slidesPerView)
    },
    updateActiveSlide () {
      this.activeSlide = this.$refs.swiper.swiper.activeIndex
    },
    handlePagination (index) {
      this.$refs.swiper.swiper.slideTo(index)
    },
  },
}
</script>

<style scoped>
.list-item {
  @apply flex items-center justify-between py-4;
}

.list-item > p {
  @apply font-header;
}

.list-item > p:first-of-type {
  @apply w-1/4;
}

.list-item > p:not(:first-of-type) {
  @apply text-center flex-1;
}

</style>
